import { useState } from "react";
import "./TheReflexChallenge.css";
import ModalBox from "../../components/ModalBox/ModalBox";
import ActivityHeader from "../../components/ActivityHeader/ActivityHeader";
import {
  initialModal,
  levelPassedModal,
  championModal,
  failEarlyModal,
  failSlowModal,
  failWrongModal,
} from "./Modals";
import { trackGameStart } from "../../utils/trackEvents";

export default function TheReflexChallenge() {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [modalContent, setModalContent] = useState(initialModal());
  const [level, setLevel] = useState(1);
  const [boxes, setBoxes] = useState([]);
  const [activeBox, setActiveBox] = useState(null);
  const [gameStarted, setGameStarted] = useState(false);
  const [startTime, setStartTime] = useState(null);

  function startNewLevel() {
    const boxCount = level === 5 ? 6 : level;
    setBoxes(Array.from({ length: boxCount }, (_, i) => ({ id: i })));
    const greenDelay = Math.random() * 2000 + 4000;
    const randomGreenIndex = Math.floor(Math.random() * boxCount);
    const maxYellowFlashes = Math.floor(Math.random() * 3);

    for (let i = 0; i < maxYellowFlashes; i++) {
      const yellowDelay = Math.random() * (greenDelay - 1000);
      const flashIndex = Math.floor(Math.random() * boxCount);
      setTimeout(() => {
        setActiveBox(flashIndex);
        setTimeout(() => setActiveBox(null), 800);
      }, yellowDelay);
    }

    setTimeout(() => {
      setActiveBox(randomGreenIndex);
      setStartTime(Date.now());
      setGameStarted(true);
      trackGameStart("TheReflexChallenge", level);
    }, greenDelay);
  }

  function handleModalClose() {
    setIsModalOpen(false);
    setBoxes([]);
    setActiveBox(null);
    setGameStarted(false);
    startNewLevel();
  }

  function showModal(contentFunc) {
    setModalContent(contentFunc);
    setIsModalOpen(true);
  }

  function handleCardClick(index) {
    if (!gameStarted) {
      setLevel(1);
      showModal(failEarlyModal());
      return;
    }

    if (index === activeBox) {
      const reactionTime = (Date.now() - startTime) / 1000;

      if (reactionTime <= 0.6) {
        if (level < 5) {
          setLevel((l) => l + 1);
          showModal(levelPassedModal(reactionTime, level));
        } else {
          setLevel(1);
          showModal(championModal(reactionTime));
        }
      } else {
        setLevel(1);
        showModal(failSlowModal(reactionTime));
      }
    } else {
      setLevel(1);
      showModal(failWrongModal());
    }
  }

  function renderCard(id, index) {
    const isActive = index === activeBox;
    const colorClass = isActive ? (gameStarted ? "green" : "yellow") : "red";

    return (
      <div
        key={id}
        className={`reflexChallenge-card ${colorClass}`}
        onClick={() => handleCardClick(index)}
      />
    );
  }

  function renderGame() {
    return boxes.length <= 3 ? (
      <div className="reflexChallenge-content-single">
        {boxes.map((box, i) => renderCard(box.id, i))}
      </div>
    ) : (
      <div className="reflexChallenge-content-multi">
        <div className="reflexChallenge-row">
          {boxes
            .slice(0, Math.ceil(boxes.length / 2))
            .map((box, i) => renderCard(box.id, i))}
        </div>
        <div className="reflexChallenge-row">
          {boxes.slice(Math.ceil(boxes.length / 2)).map((box, idx) => {
            const i = idx + Math.ceil(boxes.length / 2);
            return renderCard(`${box.id}-second`, i);
          })}
        </div>
      </div>
    );
  }

  function renderModal() {
    return (
      <ModalBox
        isOpen={isModalOpen}
        title={modalContent.title}
        description={modalContent.description}
        buttonText={modalContent.buttonText}
        buttonType={modalContent.buttonType}
        onClose={handleModalClose}
      />
    );
  }

  return (
    <div className="reflexChallenge-main">
      {!isModalOpen && (
        <>
          <ActivityHeader>Level {level}</ActivityHeader>
          <div className="reflexChallenge-game">{renderGame()}</div>
        </>
      )}
      {renderModal()}
    </div>
  );
}
